import React from 'react';

/** Small labelled chip. Tone: error · warning · info · success · neutral. */
const TONE_CLS = {
  error: 'bg-[color:var(--feedback-error-bg)] text-[color:var(--feedback-error)]',
  warning: 'bg-[color:var(--feedback-warning-bg)] text-[color:var(--feedback-warning)]',
  info: 'bg-[color:var(--feedback-info-bg)] text-[color:var(--feedback-info)]',
  success: 'bg-[color:var(--feedback-success-bg)] text-[color:var(--feedback-success)]',
  neutral: 'bg-surface-hover text-[color:var(--text-secondary)]',
};

export default function Tag({ children, tone = 'neutral', mono = false, title }) {
  return (
    <span
      title={title}
      className={`inline-flex max-w-full shrink-0 items-center truncate rounded px-1.5 py-0.5 text-[11px] font-medium leading-4 ${mono ? 'font-mono' : ''} ${TONE_CLS[tone] || TONE_CLS.neutral}`}
    >
      {children}
    </span>
  );
}
